export default __webpack_public_path__ + "static/media/telephone.ce0883f8.svg";